import React, { useState, useEffect, useRef } from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './propertyDetails.module.css';
import window from 'global';
import Helmet from 'react-helmet';
import { gsap, TweenMax, Expo } from "gsap";


function PropertyDetails(props) {

    let slug = false;
    let isIOS = false;
    let iosAppUrl = 'https://apps.apple.com/au/app/homesta/id1588096560';
    let androidAppUrl = 'https://play.google.com/store/apps/details?id=au.com.homesta';
    let oneLinkUrl = 'https://homesta.onelink.me/irbC/1bk6e8e9';
    const [appUrl, setAppUrl] = useState(oneLinkUrl);

    const [hasProperty, setHasProperty] = useState(false);
    const [metaTitle, setMetaTitle] = useState('Listing');
    const [metaDesc, setMetaDesc] = useState('');
    const [metaImage, setMetaImage] = useState('');
    const [propertyData, setPropertyData] = useState(false);
    
    const loadingMessage = "Loading listing, please wait...";
    const failMessage = "Sorry, the link provided doesn't match any listing from our server.";
    const errorMessage = "Network connection failed, please try again later.";

    // const apiEndpoint = 'https://stagingapi.homesta.com.au/api/v1.0/public/properties/property_from_slug';
    const apiEndpoint = 'https://api.homesta.com.au/api/v1.0/public/properties/property_from_slug';

    let formatter = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
      
        // These options are needed to round to whole numbers if that's what you want.
        minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    let buildListingHtml = (prop) => {

        let buildAppUrl = appUrl;
                    
        if(navigator != 'undefined'){
            isIOS = [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)

            if(isIOS){
                setAppUrl(iosAppUrl);
                buildAppUrl = iosAppUrl;
            }
        }

        let glImage1 = (prop.property_assets[0]) ? prop.property_assets[0].asset.url : '';
        let glImage2 = (prop.property_assets[1]) ? prop.property_assets[1].asset.url : '';
        let glImage3 = (prop.property_assets[2]) ? prop.property_assets[2].asset.url : '';
        let glImage4 = (prop.property_assets[3]) ? prop.property_assets[3].asset.url : '';

        let isSamePrice = (prop.from_price == prop.to_price);
        let from_price = formatter.format((prop.from_price/100));
        let to_price =  formatter.format((prop.to_price/100)) ;
        let range_price = from_price + ' - ' + to_price;
        let display_price = (isSamePrice) ? from_price : range_price;
        display_price = (display_price == '$0.00') ? 'Price not available' : display_price;

        let display_address = (prop.short_address) ? prop.short_address+', '+prop.city : prop.full_address;
        let bath_count = (prop.bath_count) ? prop.bath_count : 'N/A';
        let bed_count = (prop.bed_count) ? prop.bed_count : 'N/A';
        let car_space_count = (prop.car_space_count) ? prop.car_space_count : 'N/A';

        let display_audience = [];
        let display_attr = [];
        let audience = prop.property_audiences;
        let attributes = prop.property_attributes

        for(let ai = 0; ai < audience.length; ai++){
            let ad = audience[ai].property_audience_type;
            display_audience[ad.order] = ad.name;
        }

        for(let ati = 0; ati < attributes.length; ati++){
            let at = attributes[ati].property_attribute_type;
            display_attr[at.order] = at.name;
        }

        let is_poa = prop.is_poa;

        let html = `<div id="bl-html" class="`+styles.blHtml+`">`;
            html += `<div class="`+styles.blGallery+`">`;
                html += `<div class="`+styles.galleryWrap+`">`;
                    if(!glImage2 || glImage2.length == 0){
                        html += `<div class="`+styles.soloFeatured+`">`;
                            html += `<div class="`+styles.featuredImg+` `+styles.imgBox+`" style="background-image:url('`+glImage1+`');"></div>`;
                        html += `</div>`;
                    } else {
                        html += `<div class="`+styles.featuredCol+`">`;
                            html += `<div class="`+styles.featuredImg+` `+styles.imgBox+`" style="background-image:url('`+glImage1+`');"></div>`;
                            html += `<div class="`+styles.galleryLabel+`"><span>1/`+prop.property_assets.length+`</span><a href="`+buildAppUrl+`" target="_blank" class="`+styles.mobileLabel+`">+ More in app</a></div>`;
                        html += `</div>`;
                        html += `<div class="`+styles.moreCol+`">`;
                            html += `<div class="`+styles.moreImg+` `+styles.imgBox+`" style="background-image:url('`+glImage2+`');"></div>`;
                            html += `<div class="`+styles.moreImg+` `+styles.imgBox+`" style="background-image:url('`+glImage3+`');"></div>`;
                            html += `<div class="`+styles.moreImg+` `+styles.imgBox+`" style="background-image:url('`+glImage4+`');"></div>`;
                            html += `<a href="`+buildAppUrl+`" target="_blank" class="`+styles.moreImg+` `+styles.lastImgBox+` `+styles.imgBox+`"><span>+ More in app</span></div>`;
                        html += `</a>`;
                    }
                html += `</div>`;
            html += `</div>`;
            html += `<div class="`+styles.blDetails+`">`;
                html += `<div class="`+styles.blIntroWrap+`">`;
                    html += `<div class="`+styles.blIntro+`">`;
                        if(!is_poa){
                            html += `<h3>`+display_price+`</h3>`;
                        }
                        html += `<h5>`+prop.full_address+`</h5>`;
                        html += `<div class=`+styles.iconsBar+`>`;
                            html += `<svg xmlns="http://www.w3.org/2000/svg" width="28.699" height="19.719" viewBox="0 0 28.699 19.719">
                                        <path id="Path_19970" data-name="Path 19970" d="M236.679,962.38H234.87v-8.74a1.282,1.282,0,0,0-1.275-1.275H213.617a1.281,1.281,0,0,0-1.275,1.275v8.74h-1.817a1.281,1.281,0,0,0-1.275,1.275v5.12a1.283,1.283,0,0,0,1.275,1.276h1.225v1.168a.835.835,0,0,0,1.669.05v-1.212h20.362v1.168a.835.835,0,0,0,1.669.05v-1.218h1.225a1.281,1.281,0,0,0,1.274-1.275v-5.124a1.281,1.281,0,0,0-1.27-1.278m-22.672-8.346H233.2v8.346h-2.67v-.7a2.644,2.644,0,0,0-2.641-2.642h-8.572a2.643,2.643,0,0,0-2.643,2.641v.7h-2.668Zm14.854,7.65v.7H218.346v-.7a.975.975,0,0,1,.975-.975h8.572a.975.975,0,0,1,.968.972Zm7.425,6.706H210.919v-4.342h25.369Z" transform="translate(-209.25 -952.365)" fill="#002a3f"/>
                                    </svg>
                                    `;
                            html += `<span>`+bed_count+`</span>`;
                            html += `<svg xmlns="http://www.w3.org/2000/svg" width="21.989" height="21.62" viewBox="0 0 21.989 21.62">
                                        <path id="Path_19971" data-name="Path 19971" d="M286.5,960.606v5.586a4.532,4.532,0,0,0,4.092,4.5v.132A2.4,2.4,0,0,0,293,973.214h8.991a2.4,2.4,0,0,0,2.407-2.392v-.134a4.533,4.533,0,0,0,4.093-4.5v-5.586h-2.915v-4.974a4.04,4.04,0,0,0-8.079,0v1.037H299.1v-1.037a2.434,2.434,0,0,1,4.869,0v4.975Zm15.489,11.013H293a.8.8,0,0,1-.8-.8v-.106h10.593v.106a.8.8,0,0,1-.8.8m4.895-5.426a2.935,2.935,0,0,1-2.943,2.925H291.048a2.935,2.935,0,0,1-2.943-2.925V962.2h18.78Z" transform="translate(-286.5 -951.594)" fill="#002a3f"/>
                                    </svg>
                                    `;
                            html += `<span>`+bath_count+`</span>`;
                            html += `<svg xmlns="http://www.w3.org/2000/svg" width="26.498" height="20.61" viewBox="0 0 26.498 20.61">
                                        <path id="Path_19967" data-name="Path 19967" d="M383.409,959.063a17.914,17.914,0,0,0-1.3-4.95,4.032,4.032,0,0,0-3.738-2.5h-13.25a4,4,0,0,0-3.74,2.5,17.912,17.912,0,0,0-1.3,4.95,2.218,2.218,0,0,0-1.59,2.117v5.888a.729.729,0,0,0,.722.736h.75v3.682a.728.728,0,0,0,.722.735h2.959a.728.728,0,0,0,.735-.722.028.028,0,0,0,0-.013v-3.682H379.11v3.682a.729.729,0,0,0,.722.735h2.958a.729.729,0,0,0,.736-.722v-3.7h.736a.73.73,0,0,0,.736-.722v-5.9a2.218,2.218,0,0,0-1.589-2.121m-20.669-4.386a2.562,2.562,0,0,1,2.385-1.59h13.25a2.593,2.593,0,0,1,2.385,1.59,15.97,15.97,0,0,1,1.178,4.3h-1.415a3.663,3.663,0,0,0-7.184,0H361.562a18.525,18.525,0,0,1,1.178-4.3m16.252,4.3h-4.181a2.207,2.207,0,0,1,2.09-1.473,2.234,2.234,0,0,1,2.091,1.472Zm-16.075,11.775h-1.472v-2.943h1.472Zm19.138,0h-1.473v-2.943h1.472Zm1.472-4.417H359.972v-5.153a.729.729,0,0,1,.723-.735h22.1a.729.729,0,0,1,.736.722v5.166Z" transform="translate(-358.5 -951.615)" fill="#002a3f"/>
                                    </svg>
                                    `;
                            html += `<span>`+car_space_count+`</span>`;
                        html += `</div>`;
                        html += `<div class=`+styles.propDesc+`>`;
                            html += `<h3>`+prop.headline+`</h3>`;
                            html += `<p>`+prop.description+`</p>`;
                            html += `<a class="`+styles.readmore+`" href="`+buildAppUrl+`" target="_blank">Read more</a>`;
                        html += `</div>`;
                        html += `<div class="`+styles.mlMapWrap+`">`;
                            html += `<h3>Located here</h3>`;
                            html += `<div class="`+styles.iframeWrap+`">`;
                                html += `<div class="mapouter">
                                    <div class="gmap_canvas">
                                        <iframe width="600" height="500" id="gmap_canvas" src="https://maps.google.com/maps?q=`+encodeURI(prop.full_address)+`&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                                        </div>
                                    </div>`; 
                            html += `</div>`;
                        html += `</div>`;
                        html += `<div class="`+styles.tagsWrap+`">`;
                            html += `<div class="`+styles.tagGroup+`">`;
                                if(display_audience.length){
                                    html += `<h3>Perfect for</h3>`;
                                    display_audience.forEach((v,i) => {
                                        html += `<span class="`+styles.tagItem+`" key="`+i+`">`+v+`</span>`
                                    })
                                }
                            html += `</div>`;
                            html += `<div class="`+styles.tagGroup+`">`;
                                if(display_attr.length){
                                    html += `<h3>And featuring</h3>`;
                                    display_attr.forEach((v,i) => {
                                        html += `<span class="`+styles.tagItem+`" key="`+i+`">`+v+`</span>`
                                    })
                                }
                            html += `</div>`;
                        html += `</div>`;
                    html += `</div>`;
                    html += `<div class="`+styles.adBanner+`">`;
                        html += `<div id="sticky-ad" class="`+styles.stickyAdWrap+`">`;
                            html += `<a href="`+buildAppUrl+`" target="_blank"><img src="`+require('../images/homesta-ad-banner.png').default+`" alt="Homesta Mobile App" /></a>`;
                        html += `</div>`;        
                    html += `</div>`;
                html += `</div>`;
            html += `</div>`;
        html += `</div>`;

        return html;
    }

    useEffect(() => {
                    
        if(navigator != 'undefined'){
            isIOS = [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)

            if(isIOS){
                setAppUrl(iosAppUrl);
            }
        }

        if(document !== 'undefined'){
            if(!$('#listing-wrap').hasClass('listing-loaded')){
                const urlParams = new URLSearchParams(window.location.search);
                const property = urlParams.get('property');
                if(property){
                    slug = true;
                    let apiUrl = apiEndpoint+'?slug='+property;
                    fetch(apiUrl)
                    .then((response) => response.json())
                    .then((actualData) => {
                        if(actualData.property){
                            setHasProperty(true);
                            let prop = actualData.property;
                            setMetaTitle(prop.full_address+' | Listing');
                            setMetaDesc(prop.description);

                            if(prop.property_assets.length > 0){
                                setMetaImage(prop.property_assets[0].asset.url);
                            }

                            let propHtml = buildListingHtml(prop);

                            $('.'+styles.noMatch).fadeOut(200, () => {
                                $('#propertyDetailsWrap').html(propHtml).fadeIn();
                            });

                        } else {
                            $('.'+styles.noMatch).text(failMessage);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        $('.'+styles.noMatch).text(errorMessage);
                    });

                    $('#listing-wrap').addClass('listing-loaded');

                } else {
                    $('.'+styles.noMatch).text(failMessage);
                }
                
                TweenMax.set($('#siteTitle img'),{height: 40});
                
                if(!$('#sticky-ad').hasClass('scroll-binded')){
                    $('#sticky-ad').addClass('scroll-binded');
                    let ad_offset = ($('#sticky-ad').offset()) ? $('#sticky-ad').offset().top : 1100;

                    $(window).on('scroll', function(){
                        let current_scroll = $(window).scrollTop();
                        let offset = 250;

                        if((current_scroll + offset) > ad_offset){
                            if(!$('#sticky-ad').hasClass(styles.stickyMode)){
                                $('#sticky-ad').addClass(styles.stickyMode);
                            }
                        } else {
                            if($('#sticky-ad').hasClass(styles.stickyMode)){
                                $('#sticky-ad').removeClass(styles.stickyMode);
                            }
                        }
                    })
                }
            }
        }
    });

    return (
        <div id="listing-wrap">
            <Helmet>
                <title>{metaTitle}</title>
                <meta name="description" content={metaDesc} />
                <meta property="og:title" key="og:title" content={metaTitle} />
                <meta
                    property="og:description"
                    key="og:description"
                    content={metaDesc}
                />
                <meta
                    property="og:image"
                    key="og:image"
                    content={metaImage}
                /> 
                <meta name="twitter:title" content={metaTitle} />
                <meta name="twitter:description" content={metaDesc} /> 
            </Helmet>
            <div className={styles.stickyHeader}>
                <div className={styles.logoWrap}>
                </div>
                <div className={styles.downloadBar}>
                    <div className={styles.dbFlex}>
                        <div className={styles.dbDesc}>
                            <a href={oneLinkUrl} className={styles.descWrap} target="_blank">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 42 42">
                                    <switch>
                                        <g>
                                            <g>
                                                <path id="Rectangle_1647" style={{fill:'#FB7822'}} d="M10.2848015,0.0000415h21.430397
                                                    c5.680397,0,10.2852745,4.6048741,10.2852745,10.2852736v21.4293671c0,5.6804008-4.6048775,10.2852745-10.2852745,10.2852745
                                                    h-21.430397c-5.6803999,0-10.2852736-4.6048737-10.2852736-10.2852745V10.2853155
                                                    C-0.0004724,4.6049156,4.6044016,0.0000415,10.2848015,0.0000415z"/>
                                                <path style={{fill:'#FFFFFF'}} d="M27.8346672,25.256546c-0.0212402-0.4771118-0.2768555-0.9129028-0.6829224-1.1643066l-3.7747192-2.8129883
                                                    l-2.7307129-2.0519409c0,0-0.0339355-0.027771-0.0514526-0.0380249l-1.5767212-1.1776733
                                                    c-1.5825195-1.041687-2.2731934-3.0129404-1.6867676-4.8145151c0.6535645-2.1316528,2.911377-3.329834,5.0429688-2.6762695
                                                    c1.4879761,0.4562378,2.5811768,1.7271729,2.8098145,3.2666016c0.3262939,1.8634644-0.6403809,3.713624-2.3563232,4.5101328
                                                    c-0.0333252,0.0162354-0.067688,0.0303345-0.1029053,0.0421753c-0.1231689,0.0733032-0.1983032,0.2063599-0.1974487,0.3496704
                                                    c0.0059814,0.1435547,0.0831299,0.2747192,0.2056885,0.3497314c0.3579102,0.2622681,0.7199707,0.5245361,1.0645142,0.7970581
                                                    l0.3887939,0.300354c0.1810303,0.1367798,0.3579712,0.2900391,0.5698242,0.1254883s0.3959961-0.3085938,0.5934448-0.4680176
                                                    c1.0251465-0.850708,1.7785034-1.9830933,2.1671143-3.2573242c0.206604-0.6593637,0.3106689-1.3465586,0.3085327-2.0375376
                                                    c0.0315552-3.1876831-2.1643677-5.9656982-5.2732544-6.6710205c-3.1052856-0.6499634-6.2346191,0.9971313-7.4567862,3.9248657
                                                    c-1.269043,2.9404297-0.3502197,6.3674326,2.2195425,8.2786264l5.6003418,4.1521606h0.0174561
                                                    c0.0153198,0.0108643,0.0291748,0.0236816,0.0411377,0.0380859l2.2730713,1.6846924l0.5081177,6.0426025h-3.2686768v-2.914856
                                                    c-0.0780029-0.6496582-0.6550293-1.1218262-1.307251-1.0696411c-0.3309326-0.0029297-0.65271,0.1082153-0.9113159,0.3146973
                                                    c-0.2329102,0.1821899-0.3718872,0.4592896-0.378479,0.7549438v2.914856h-3.2840576l0.5039673-6.0322876l2.5219116-1.8513794
                                                    c0.1120605-0.0827637,0.1820068-0.2106934,0.1913452-0.3496704c0-0.2406616-0.1882324-0.3497314-0.3414917-0.4824219
                                                    l-0.378479-0.2797241c-0.3085938-0.2304077-0.6243286-0.4577026-0.9349365-0.6994019
                                                    c-0.0683594-0.0472412-0.149353-0.0726929-0.2324829-0.0730591c-0.0817871,0.0001831-0.1615601,0.0256958-0.2283325,0.0730591
                                                    l-2.5280752,1.8657227c-0.4192505,0.2982178-0.6622925,0.7857666-0.6480103,1.3001099l-0.918457,7.8496704
                                                    c-0.0037231,0.3510132,0.1307373,0.6894531,0.3743896,0.9421387c0.2396851,0.2496338,0.5703735,0.3913574,0.9164429,0.3928833
                                                    h12.5480337c0.7227173-0.0067749,1.3032227-0.5979004,1.296936-1.3206177L27.8346672,25.256546z"/>
                                            </g>
                                        </g>
                                    </switch>
                                </svg>
                                <span>View the full listing in the app</span>
                                <span className={styles.mobileDesc}>View the full listing in the app</span>
                            </a>
                        </div>
                        <div className={styles.dbAction}>
                            <a href={oneLinkUrl} target="_blank" className={styles.ctaButton}>Message the owner</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.sectionPropertyDetails}>
                <h5 className={styles.noMatch}>{loadingMessage}</h5>
                <div className={styles.pdWrap} id="propertyDetailsWrap"></div>
            </div>
            <a href={oneLinkUrl} target="_blank" className={styles.mobileStickFooter}>Message the owner</a>
        </div>
    );
}
  
export default PropertyDetails;